/* DSG — search results / listing: live filtering through the Section Rendering API,
   mobile filter drawer (stays open while filtering), sort, view toggle, "did you mean". */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const UI = () => window.DSGUI;
  let ctl;

  function formURL(form) {
    const fd = new FormData(form);
    $$('select[name="sort_by"]').forEach(s => fd.set('sort_by', s.value));
    const p = new URLSearchParams();
    for (const [k, v] of fd) if (v !== '') p.append(k, v);
    return form.action + '?' + p.toString();
  }
  async function render(url, { keepDrawer = true } = {}) {
    const root = $('[data-srp]'); if (!root) return;
    const id = root.dataset.sectionId;
    const drawerOpen = $('#filters').classList.contains('is-open');
    const scroll = $('.srp-filters__body').scrollTop;
    const openGroups = $$('.fgroup[open]').map(d => d.dataset.group);
    const focusId = document.activeElement && document.activeElement.id;
    ctl && ctl.abort(); ctl = new AbortController();
    root.setAttribute('aria-busy', 'true');
    try {
      const html = await (await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + id, { signal: ctl.signal })).text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-srp]');
      root.innerHTML = next.innerHTML;
      history.replaceState(null, '', url);
      $$('.fgroup').forEach(d => { if (openGroups.includes(d.dataset.group)) d.open = true; });
      if (keepDrawer && drawerOpen) openDrawer(false);
      $('.srp-filters__body').scrollTop = scroll;
      if (focusId) { const el = document.getElementById(focusId); el && el.focus({ preventScroll: true }); }
      applyView();
    } catch (e) { if (e.name !== 'AbortError') location.href = url; }
    finally { root.removeAttribute('aria-busy'); }
  }
  function openDrawer(focus = true) {
    const f = $('#filters'); f.classList.add('is-open'); f.setAttribute('role', 'dialog'); f.setAttribute('aria-modal', 'true');
    $('.filters-scrim').hidden = false; UI().lockScroll(true); $('[data-open-filters]').setAttribute('aria-expanded', 'true');
    if (focus) setTimeout(() => $('.srp-filters__head button').focus(), 50);
  }
  function closeDrawer() {
    const f = $('#filters'); if (!f || !f.classList.contains('is-open')) return;
    f.classList.remove('is-open'); f.removeAttribute('role'); f.removeAttribute('aria-modal');
    $('.filters-scrim').hidden = true; UI().lockScroll(false);
    const b = $('[data-open-filters]'); b.setAttribute('aria-expanded', 'false'); b.focus();
  }
  function applyView() {
    const v = UI().store.get('view', null); if (!v) return;
    $$('[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === v)));
    const r = $('[data-results]'); r && r.classList.toggle('results--grid', v === 'grid');
  }

  document.addEventListener('change', e => {
    const t = e.target, form = $('[data-filters-form]'); if (!form) return;
    if (t.closest('[data-filters-form]') && t.type === 'checkbox') render(formURL(form));
    if (t.name === 'sort_by') { $$('select[name="sort_by"]').forEach(s => s.value = t.value); render(formURL(form)); }
  });
  document.addEventListener('submit', e => { if (e.target.matches('[data-filters-form]')) { e.preventDefault(); render(formURL(e.target)); } });
  document.addEventListener('click', e => {
    const b = e.target.closest('a, button'); if (!b || !$('[data-srp]')) return;
    if (b.matches('.chip, [data-clear-all], .pager a')) { e.preventDefault(); render(b.href); if (b.closest('.pager')) window.scrollTo(0, 0); }
    if (b.matches('[data-open-filters]')) openDrawer();
    if (b.matches('[data-close-filters]')) closeDrawer();
    if (b.matches('[data-view]')) { UI().store.set('view', b.dataset.view); applyView(); }
    if (b.matches('[data-more]')) { $$('[data-more-item]', b.closest('.fgroup__body')).forEach(li => li.hidden = false); b.remove(); }
  });
  document.addEventListener('input', e => { if (e.target.matches('[data-fsearch]')) { const v = e.target.value.toLowerCase(); $$('li', e.target.closest('.fgroup__body')).forEach(li => li.hidden = !li.textContent.toLowerCase().includes(v)); } });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // "Did you mean": try common part-number slips (adjacent transpositions, one dropped/extra char)
  async function didYouMean() {
    const box = $('[data-did-you-mean]'); if (!box) return;
    const q = box.dataset.terms.replace(/\s+/g, ''); if (q.length < 4 || q.length > 24) return;
    const cands = new Set();
    for (let i = 0; i < q.length - 1; i++) cands.add(q.slice(0, i) + q[i + 1] + q[i] + q.slice(i + 2));
    for (let i = 0; i < q.length; i++) cands.add(q.slice(0, i) + q.slice(i + 1));
    const R = window.DSG.routes, found = new Map();
    await Promise.all([...cands].slice(0, 16).map(async c => {
      try { const j = await (await fetch(`${R.predictive}.json?q=${encodeURIComponent(c)}&resources[type]=product&resources[limit]=1&resources[options][fields]=variants.sku,title,tag`)).json(); const p = j.resources.results.products[0]; if (p) found.set(p.handle, { c, p }); } catch { /* ignore */ }
    }));
    if (!found.size) return;
    box.innerHTML = `<p class="noresults__dym">Did you mean ${[...found.values()].slice(0, 3).map(({ c, p }) => `<a href="${p.url}">${c.toUpperCase()}</a>`).join(', ')}?</p>`;
    box.hidden = false;
  }
  document.addEventListener('DOMContentLoaded', () => { applyView(); didYouMean(); });
})();
